import { render, staticRenderFns } from "./no-product-page.vue?vue&type=template&id=53e89494&scoped=true&"
import script from "./no-product-page.vue?vue&type=script&lang=js&"
export * from "./no-product-page.vue?vue&type=script&lang=js&"
import style0 from "./no-product-page.vue?vue&type=style&index=0&id=53e89494&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e89494",
  null
  
)

export default component.exports